import "./styles.css";
import SyntaxHighlighter from "react-syntax-highlighter";
import { LoremIpsum } from "lorem-ipsum";
import parse from "html-react-parser";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/hljs";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Toast, ToastWrapper } from "show-toast-box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuIcon from "@mui/icons-material/Menu";
import { SentimentSatisfied } from "@mui/icons-material";
import { object } from "prop-types";

export default function App() {
  // 'ToastWrapper' Reference - Use 'wrapper' to access the 'ToastWrapper' class.
  let wrapper = useRef();
  let toastProps = undefined;
  let [generatedCode, setGeneratedCode] = useState("<Toast />");
  let appTheme = "light";

  // "Toast" Properties ...
  let [title, setTitle] = useState("Toast Title ✨");
  let [description, setDescription] = useState("");
  let [type, setType] = useState("info");
  let [theme, setTheme] = useState("light");
  let [animation, setAnimation] = useState("slide-down");
  let [animationCss, setAnimationCss] = useState("");
  let [autoRemove, setAutoRemove] = useState(false);
  let [removeWhenClick, setRemoveWhenClick] = useState(false);
  let [removeWhenClickText, setRemoveWhenClickText] = useState(
    "click to dismiss"
  );
  let [direction, setDirection] = useState("ltr");
  let [loading, setLoading] = useState(false);
  let [loaderLoaded, setLoaderLoaded] = useState(false);
  let [loaderText, setLoaderText] = useState("Loading in progress...");
  let [loaderSize, setLoaderSize] = useState("small");
  let [delay, setDelay] = useState(undefined);
  let [showProgress, setShowProgress] = useState(true);
  let [pauseWhenHover, setPauseWhenHover] = useState(true);
  let [duration, setDuration] = useState(undefined);
  let [animationDuration, setAnimationDuration] = useState(500);
  let [icon, setIcon] = useState(undefined);
  let [removeWhenDrag, setRemoveWhenDrag] = useState(false);
  let [actionTitle1, setActionTitle1] = useState(undefined);
  let [actionTitle2, setActionTitle2] = useState(undefined);
  let [actionIcon1, setActionIcon1] = useState(undefined);
  let [actionIcon2, setActionIcon2] = useState(undefined);
  let [pauseWhenWindowUnfocus, setPauseWhenWindowUnfocus] = useState(true);
  let [onRemove, setOnRemove] = useState(undefined);
  let [onAdd, setOnAdd] = useState(undefined);

  // "Toast" default properties --> "D" stands for default
  const titleD = "Toast Title ✨";
  const descriptionD = "";
  const typeD = "info";
  const themeD = "light";
  const animationD = "slide-down";
  const autoRemoveD = false;
  const removeWhenClickD = false;
  const removeWhenClickTextD = "click to dismiss";
  const directionD = "ltr";
  const loadingD = false;
  const loaderLoadedD = false;
  const loaderTextD = "Loading in progress...";
  const loaderSizeD = "small";
  const delayD = 0;
  const showProgressD = true;
  const pauseWhenHoverD = true;
  const durationD = undefined;
  const animationDurationD = 500;
  const iconD = undefined;
  const removeWhenDragD = false;
  const actionTitle1D = undefined;
  const actionTitle2D = undefined;
  const actionIcon1D = undefined;
  const actionIcon2D = undefined;
  const pauseWhenWindowUnfocusD = true;
  const onRemoveD = undefined;
  const onAddD = undefined;

  // "ToastWrapper" Properties ...
  // *Note: All "Toast" properties can be set globally (for all toasts) on "ToastWrapper"
  let [placement, setPlacement] = useState("bottom-right");
  let [userCanRemoveAll, setUserCanRemoveAll] = useState(false);
  let [removeAllText, setRemoveAllText] = useState(undefined);
  let [limit, setLimit] = useState(undefined);
  let [spacing, setSpacing] = useState(10);

  // App JS States
  let [toastWrapperIcon, setToastWrapperIcon] = useState(true);
  let [toastIcon, setToastIcon] = useState(true);
  let [random, setRandom] = useState(false);

  let generateCode = () => {
    let code = "<Toast\n";
    let count = 0;
    for (let prop in toastProps) {
      let value = toastProps[prop];
      let defaultVal = undefined;
      eval(`defaultVal = ${prop}D`);
      if (defaultVal !== value) {
        let valueStr = "";
        let type = typeof value;
        if (type === "string") valueStr = `"${value}"`;
        else valueStr = `{${value}}`;
        code += `\t${prop}=${valueStr} \n`;
        count++;
      }
    }
    code += "/>";
    if (count === 0) code = "<Toast />";
    navigator.clipboard.writeText(code);
    setGeneratedCode(code);
  };
  let varToString = (varObject) => {
    return Object.keys(varObject)[0];
  };
  let randomChanged = (e) => {
    setRandom(e.currentTarget.checked);
  };
  let titleChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setTitle(value);
  };
  let descriptionChanged = (e) => {
    let target = e.currentTarget;
    let value = parse(target.value);
    if (value === "" || value === undefined) value = undefined;
    setDescription(value);
  };
  let removeWhenDragChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    setRemoveWhenDrag(checked);
  };
  let autoRemoveChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    let container = document.querySelector("#auto-remove");
    if (checked) container.style.display = "block";
    else container.style.display = "none";
    setAutoRemove(checked);
  };
  let showProgressChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    setShowProgress(checked);
  };
  let loadingChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    let container = document.querySelector("#loader-text");
    if (checked) container.style.display = "block";
    else container.style.display = "none";
    setLoading(checked);
  };
  let loadedChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    setLoaderLoaded(checked);
  };
  let pauseWhenHoverChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    setPauseWhenHover(checked);
  };
  let loaderSizeChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setLoaderSize(value);
  };
  let directionChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setDirection(value);
  };
  let iconChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setIcon(parse(value));
  };
  let delayChanged = (e) => {
    let target = e.currentTarget;
    let value = parseInt(target.value);
    if (value === "" || value === undefined || isNaN(value)) value = undefined;
    setDelay(value);
  };
  let durationChanged = (e) => {
    let target = e.currentTarget;
    let value = parseInt(target.value);
    if (value === "" || value === undefined) return;
    setDuration(value);
  };
  let animationDurationChanged = (e) => {
    let target = e.currentTarget;
    let value = parseInt(target.value);
    if (value === "" || value === undefined || isNaN(value)) value = undefined;
    setAnimationDuration(value);
  };
  let removeWhenClickChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    let container = document.querySelector("#remove-when-click-text");
    if (checked) container.style.display = "block";
    else container.style.display = "none";
    setRemoveWhenClick(checked);
  };
  let removeWhenClickTextChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setRemoveWhenClickText(value);
  };
  let typeChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setType(value);
  };
  let themeChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setTheme(value);
  };
  let animationChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined || animationCss !== "") return;
    setAnimation(value);
  };
  let animationCssChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value !== "") setAnimation(`>${value}`);
    else setAnimation("slide-down");
  };
  let loaderTextChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setLoaderText(value);
  };
  let actionTitle1Changed = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setActionTitle1(value);
  };
  let actionTitle2Changed = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setActionTitle2(value);
  };
  let actionIcon1Changed = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setActionIcon1(value);
  };
  let actionIcon2Changed = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setActionIcon2(value);
  };
  let placementChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) return;
    setPlacement(value);
  };
  let removeAllTextChanged = (e) => {
    let target = e.currentTarget;
    let value = target.value;
    if (value === "" || value === undefined) value = undefined;
    setRemoveAllText(value);
  };
  let limitChanged = (e) => {
    let target = e.currentTarget;
    let value = parseInt(target.value);
    if (value === "" || value === undefined || isNaN(value)) value = undefined;
    setLimit(value);
  };
  let spacingChanged = (e) => {
    let target = e.currentTarget;
    let value = parseInt(target.value);
    if (value === "" || value === undefined || isNaN(value)) value = 10;
    setSpacing(value);
  };
  let canUserRemoveAllChanged = (e) => {
    let target = e.currentTarget;
    let checked = target.checked;
    let container = document.querySelector("#can-user-remove-all");
    if (checked) container.style.display = "block";
    else container.style.display = "none";
    setUserCanRemoveAll(checked);
  };

  let expandProperties = (id, open) => {
    let container = document.querySelector(`#${id}`);
    if (open) container.style.height = `0`;
    else container.style.height = `auto`;

    if (id === "toast-properties") {
      setToastIcon(!toastIcon);
    } else if (id === "toast-wrapper-properties") {
      setToastWrapperIcon(!toastWrapperIcon);
    }
  };
  let addToast = () => {
    let toast = (
      <Toast
        title={title}
        description={description}
        type={type}
        theme={theme}
        animation={animation}
        autoRemove={autoRemove}
        removeWhenClick={removeWhenClick}
        removeWhenClickText={removeWhenClickText}
        direction={direction}
        loading={loading}
        loaderLoaded={loaderLoaded}
        loaderText={loaderText}
        loaderSize={loaderSize}
        delay={delay}
        showProgress={showProgress}
        pauseWhenHover={pauseWhenHover}
        duration={duration}
        animationDuration={animationDuration}
        icon={icon}
        removeWhenDrag={removeWhenDrag}
        actionTitle1={actionTitle1}
        actionTitle2={actionTitle2}
        actionIcon1={actionIcon1}
        actionIcon2={actionIcon2}
      />
    );
    wrapper.current.add(toast);
  };
  let addToastsGroup = () => {
    let input = document.querySelector("#add-toasts-group");
    let active = document.activeElement;
    if (input === active) return;
    let intValue = parseInt(input.textContent);
    let value = !isNaN(intValue) && intValue !== "" ? intValue : 5;
    for (let i = 0; i < value; i++)
      if (random) addRandomToastClicked();
      else addToast();
  };
  let randBetween = (min, max) => {
    return Math.round(Math.random() * (max - min) + min);
  };
  let addRandomToastClicked = () => {
    const lorem = new LoremIpsum({
      sentencesPerParagraph: {
        max: 4,
        min: 1
      },
      wordsPerSentence: {
        max: 5,
        min: 1
      }
    });
    let types = ["info", "warning", "error", "success"];
    let animations = [
      "side-down",
      "slide-up",
      "slide-left",
      "slide-right",
      "zoom-in",
      "zoom-out",
      "none"
    ];
    let directions = ["ltr", "rtl"];
    let booleans = [true, false];
    let actionTitles1 = ["Ok", undefined, "Yes", "Nice", "Good", "Continue"];
    let actionTitles2 = ["Cancel", undefined, "No", "Not Now"];
    let actionIcons = [
      "bi bi-heart",
      "bi bi-heart-fill",
      "bi bi-check",
      undefined
    ];
    let icons = [
      "🎈",
      "🎇",
      "🎃",
      "🎁",
      "🎀",
      "❌",
      "🛑",
      "✅",
      "❎",
      "🥐",
      "🍉",
      undefined
    ];
    let themes = ["dark", "light", "colorful"];
    let loadingTexts = [
      "Loading...",
      "Loading In Progress...",
      "Please Wait...",
      "We're Working On It..."
    ];

    // "R" stands for "random"
    let titleR = lorem.generateSentences(1);
    let descriptionR = [lorem.generateParagraphs(1), undefined][
      randBetween(0, 1)
    ];
    let typeR = types[randBetween(0, types.length - 1)];
    let themeR = themes[randBetween(0, themes.length - 1)];
    let animationR = animations[randBetween(0, animations.length - 1)];
    let autoRemoveR = booleans[randBetween(0, 1)];
    let removeWhenClickR = booleans[randBetween(0, 1)];
    let removeWhenClickTextR = undefined;
    let directionR = undefined;
    let loadingR = booleans[randBetween(0, 1)];
    let loaderLoadedR = booleans[randBetween(0, 1)];
    let loaderTextR = loadingTexts[randBetween(0, loadingTexts.length - 1)];
    let loaderSizeR = "small";
    let delayR = undefined;
    let showProgressR = booleans[randBetween(0, 1)];
    let pauseWhenHoverR = booleans[randBetween(0, 1)];
    let durationR = undefined;
    let animationDurationR = undefined;
    let removeWhenDragR = booleans[randBetween(0, 1)];
    let iconR = icons[randBetween(0, icons.length - 1)];
    let actionTitle1R = actionTitles1[randBetween(0, actionTitles1.length - 1)];
    let actionIcon1R = actionIcons[randBetween(0, actionIcons.length - 1)];
    let actionTitle2R = actionTitles2[randBetween(0, actionTitles2.length - 1)];
    let actionIcon2R = actionIcons[randBetween(0, actionIcons.length - 1)];

    let toast = (
      <Toast
        title={titleR}
        description={descriptionR}
        type={typeR}
        theme={themeR}
        animation={animationR}
        autoRemove={autoRemoveR}
        removeWhenClick={removeWhenClickR}
        removeWhenClickText={removeWhenClickTextR}
        direction={directionR}
        loading={loadingR}
        loaderLoaded={loaderLoadedR}
        loaderText={loaderTextR}
        loaderSize={loaderSizeR}
        delay={delayR}
        showProgress={showProgressR}
        pauseWhenHover={pauseWhenHoverR}
        duration={durationR}
        animationDuration={animationDurationR}
        icon={iconR}
        removeWhenDrag={removeWhenDragR}
        actionTitle1={actionTitle1R}
        actionTitle2={actionTitle2R}
        actionIcon1={actionIcon1R}
        actionIcon2={actionIcon2R}
      />
    );
    wrapper.current.add(toast);
  };
  let search = () => {
    let target = document.querySelector('#search-in input[type="text"]');

    // expandProperties("toast-properties", false);
    // expandProperties("toast-wrapper-properties", false);

    let searchItems = document.querySelectorAll(".search-item");
    let value = target.value.trim().toLowerCase();

    searchItems.forEach((si) => {
      let label = si.getAttribute("aria-label").trim().toLowerCase();
      if (!label.includes(value)) si.style.display = "none";
      else si.style.display = "block";
    });
  };
  let themeTo = (theme) => {
    let body = document.body;
    let storage = localStorage;
    if (theme === "light") {
      body.style.setProperty("--main-bg", "white");
      body.style.setProperty("--neutral-1", "#eee");
      body.style.setProperty("--neutral-2", "#ccc");
      body.style.setProperty("--neutral-3", "gray");
      body.style.setProperty("--neutral-4", "#dadada");
      body.style.setProperty("--text", "black");
      storage.setItem("theme", "light");
    } else if (theme === "dark") {
      body.style.setProperty("--main-bg", "#222");
      body.style.setProperty("--neutral-1", "#333");
      body.style.setProperty("--neutral-2", "#444");
      body.style.setProperty("--neutral-3", "#111");
      body.style.setProperty("--neutral-4", "#555");
      body.style.setProperty("--text", "white");
      storage.setItem("theme", "dark");
    }
  };
  let themeClicked = (e) => {
    appTheme = appTheme === "light" ? "dark" : "light";
    themeTo(appTheme);
  };
  useEffect(() => {
    let toast = (
      <Toast
        title={title}
        description={description}
        type={type}
        theme={theme}
        animation={animation}
        autoRemove={autoRemove}
        removeWhenClick={removeWhenClick}
        removeWhenClickText={removeWhenClickText}
        direction={direction}
        loading={loading}
        loaderLoaded={loaderLoaded}
        loaderText={loaderText}
        loaderSize={loaderSize}
        delay={delay}
        showProgress={showProgress}
        pauseWhenHover={pauseWhenHover}
        duration={duration}
        animationDuration={animationDuration}
        icon={icon}
        removeWhenDrag={removeWhenDrag}
        actionTitle1={actionTitle1}
        actionTitle2={actionTitle2}
        actionIcon1={actionIcon1}
        actionIcon2={actionIcon2}
      />
    );
    toastProps = toast.props;
    window.onload = () => {
      let storage = localStorage;
      let storageTheme = storage.getItem("theme");
      if (storageTheme === null) storageTheme = "light";
      themeTo(storageTheme);
      appTheme = storageTheme;
    };
    window.onkeypress = (e) => {
      let input = document.querySelector('#search-in input[type="text"]');
      if (e.key === "/") {
        if (input === document.activeElement) return;
        input.focus();
        setTimeout(() => {
          let value = input.value;
          input.value = value.substr(0, value.length - 1);
          search();
        }, 0);
      }
    };
  });
  return (
    <div className="App">
      <IconButton
        id="menu-btn"
        onClick={() => {
          let sidebar = document.querySelector("#properties-sidebar");
          let display = getComputedStyle(sidebar).getPropertyValue("display");
          if (display === "none") sidebar.style.display = "flex";
          else sidebar.style.display = "none";
        }}
      >
        <MenuIcon />
      </IconButton>
      <div id="properties-sidebar">
        <div id="properties-sidebar-header">
          <div id="logo">
            <div>show-toast-box</div>
            <span>.js</span>
          </div>
          <i class="bi bi-circle-half" onClick={themeClicked}></i>
        </div>
        <div id="search-in">
          <input type="text" placeholder="Filter..." onChange={search} />
          <div id="search-inner">
            <i className="bi bi-funnel"></i>
            <p>/</p>
          </div>
        </div>
        <div id="properties-inner">
          <h3>
            Toast
            <IconButton
              onClick={() => {
                expandProperties("toast-properties", toastIcon);
              }}
            >
              {toastIcon ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </IconButton>
          </h3>
          <Stack id="toast-properties" className="properties-type" spacing={2}>
            <TextField
              id="filled-basic"
              className="search-item"
              aria-label="title"
              label="Title"
              variant="outlined"
              size="small"
              onChange={titleChanged}
              value={title}
            />
            <Tooltip
              title="You can put text or HTML markup"
              placement="top-start"
            >
              <TextField
                id="filled-basic"
                className="search-item"
                aria-label="description"
                label="Description"
                variant="outlined"
                size="small"
                onChange={descriptionChanged}
              />
            </Tooltip>
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="type info warning error success"
            >
              <FormLabel component="legend">Type</FormLabel>
              <RadioGroup row aria-label="type" name="type-radio-buttons-group">
                <FormControlLabel
                  value="info"
                  control={
                    <Radio
                      onChange={typeChanged}
                      checked={type === "info" ? true : false}
                    />
                  }
                  label="Info"
                />
                <FormControlLabel
                  value="warning"
                  control={<Radio onChange={typeChanged} />}
                  label="Warning"
                />
                <FormControlLabel
                  value="error"
                  control={<Radio onChange={typeChanged} />}
                  label="Error"
                />
                <FormControlLabel
                  value="success"
                  control={<Radio onChange={typeChanged} />}
                  label="Success"
                />
              </RadioGroup>
            </FormControl>
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="theme dark light colorful"
            >
              <FormLabel component="legend">Theme</FormLabel>
              <RadioGroup
                row
                aria-label="theme"
                name="theme-radio-buttons-group"
              >
                <FormControlLabel
                  value="light"
                  control={
                    <Radio
                      onChange={themeChanged}
                      checked={theme === "light" ? true : false}
                    />
                  }
                  label="Light"
                />
                <FormControlLabel
                  value="dark"
                  control={<Radio onChange={themeChanged} />}
                  label="Dark"
                />
                <FormControlLabel
                  value="colorful"
                  control={<Radio onChange={themeChanged} />}
                  label="Colorful"
                />
              </RadioGroup>
            </FormControl>
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="animation slide left slide right slide down slide up zoom in zoom out none"
            >
              <FormLabel component="legend">
                Animation&nbsp;&nbsp;
                <Tooltip title="Set animation transition type" arrow>
                  <i className="bi bi-info-circle-fill"></i>
                </Tooltip>
              </FormLabel>
              <RadioGroup
                row
                aria-label="animation"
                name="animation-radio-buttons-group"
              >
                <FormControlLabel
                  value="slide-down"
                  control={
                    <Radio
                      onChange={animationChanged}
                      checked={animation === "slide-down" ? true : false}
                    />
                  }
                  label="Slide Down"
                />
                <FormControlLabel
                  value="slide-up"
                  control={<Radio onChange={animationChanged} />}
                  label="Slide Up"
                />
                <FormControlLabel
                  value="slide-left"
                  control={<Radio onChange={animationChanged} />}
                  label="Slide Left"
                />
                <FormControlLabel
                  value="slide-right"
                  control={<Radio onChange={animationChanged} />}
                  label="Slide Right"
                />
                <FormControlLabel
                  value="zoom-in"
                  control={<Radio onChange={animationChanged} />}
                  label="Zoom In"
                />
                <FormControlLabel
                  value="zoom-out"
                  control={<Radio onChange={animationChanged} />}
                  label="Zoom Out"
                />
                <FormControlLabel
                  value="none"
                  control={<Radio onChange={animationChanged} />}
                  label="None"
                />
              </RadioGroup>
              <TextField
                label="'animation.css' class"
                size="small"
                variant="outlined"
                onChange={animationCssChanged}
              />
            </FormControl>
            <div
              className="search-item"
              aria-label="auto remove show progress pause on hover duration"
            >
              <FormControlLabel
                checked={autoRemove}
                control={<Checkbox onChange={autoRemoveChanged} />}
                label="Auto Remove"
              />
              <div id="auto-remove">
                <FormControlLabel
                  checked={showProgress}
                  control={<Checkbox onChange={showProgressChanged} />}
                  label="Show Progress"
                />
                <FormControlLabel
                  checked={pauseWhenHover}
                  control={<Checkbox onChange={pauseWhenHoverChanged} />}
                  label="Pause When Hover"
                />
                <TextField
                  label="Duration (ms)"
                  size="small"
                  variant="outlined"
                  onChange={durationChanged}
                  type="number"
                />
              </div>
            </div>
            <div className="search-item" aria-label="remove when click text">
              <FormControlLabel
                checked={removeWhenClick}
                control={<Checkbox onChange={removeWhenClickChanged} />}
                label="Remove When Click"
              />
              <div id="remove-when-click-text">
                <TextField
                  label="Remove When Click Text"
                  size="small"
                  variant="outlined"
                  onChange={removeWhenClickTextChanged}
                />
              </div>
            </div>
            <div
              className="search-item"
              aria-label="loading state loaded state loader text loader size"
            >
              <FormControlLabel
                checked={loading}
                control={<Checkbox onChange={loadingChanged} />}
                label="Loading State"
              />
              <div id="loader-text">
                <TextField
                  label="Loading Text"
                  size="small"
                  variant="outlined"
                  onChange={loaderTextChanged}
                />
                <FormControlLabel
                  checked={loaderLoaded}
                  control={<Checkbox onChange={loadedChanged} />}
                  label="Loaded State"
                />
                <FormControl component="fieldset">
                  <FormLabel component="legend">Loader Size</FormLabel>
                  <RadioGroup
                    row
                    aria-label="loader-size"
                    name="loader-size-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="small"
                      control={
                        <Radio
                          onChange={loaderSizeChanged}
                          checked={loaderSize === "small" ? true : false}
                        />
                      }
                      label="Small"
                    />
                    <FormControlLabel
                      value="medium"
                      control={<Radio onChange={loaderSizeChanged} />}
                      label="Medium"
                    />
                    <FormControlLabel
                      value="large"
                      control={<Radio onChange={loaderSizeChanged} />}
                      label="Large"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <FormControlLabel
              className="search-item"
              aria-label="remove when drag"
              checked={removeWhenDrag}
              control={<Checkbox onChange={removeWhenDragChanged} />}
              label="Remove When Drag"
            />
            <Tooltip
              title="You can put text or HTML markup"
              placement="top-start"
            >
              <TextField
                className="search-item"
                aria-label="icon"
                label="Icon"
                size="small"
                variant="outlined"
                onChange={iconChanged}
              />
            </Tooltip>
            <Tooltip
              title="The delay time before the toast displayed in milliseconds"
              placement="top-start"
            >
              <TextField
                className="search-item"
                aria-label="delay"
                label="Delay"
                size="small"
                variant="outlined"
                onChange={delayChanged}
                type="number"
              />
            </Tooltip>
            <Tooltip
              title="The transition duration of the toast animation in milliseconds"
              placement="top-start"
            >
              <TextField
                className="search-item"
                aria-label="animation duration"
                label="Animation Duration"
                size="small"
                variant="outlined"
                onChange={animationDurationChanged}
                type="number"
              />
            </Tooltip>
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="actions action title action icon"
            >
              <FormLabel component="legend">
                Actions&nbsp;&nbsp;
                <Tooltip title="Here you can add up to tow action button" arrow>
                  <i className="bi bi-info-circle-fill"></i>
                </Tooltip>
              </FormLabel>
              <Stack spacing={1}>
                <TextField
                  label="Action Title 1"
                  size="small"
                  variant="outlined"
                  onChange={actionTitle1Changed}
                />
                <TextField
                  label="Action Icon 1"
                  size="small"
                  variant="outlined"
                  onChange={actionIcon1Changed}
                />
                <TextField
                  label="Action Title 2"
                  size="small"
                  variant="outlined"
                  onChange={actionTitle2Changed}
                />
                <TextField
                  label="Action Icon 2"
                  size="small"
                  variant="outlined"
                  onChange={actionIcon2Changed}
                />
              </Stack>
            </FormControl>
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="direction ltr rtl left to right to left"
            >
              <FormLabel component="legend">Direction</FormLabel>
              <RadioGroup
                row
                aria-label="theme"
                name="direction-radio-buttons-group"
              >
                <FormControlLabel
                  value="ltr"
                  control={
                    <Radio
                      onChange={directionChanged}
                      checked={direction === "ltr" ? true : false}
                    />
                  }
                  label="Left To Right"
                />
                <FormControlLabel
                  value="rtl"
                  control={<Radio onChange={directionChanged} />}
                  label="Right To Left"
                />
              </RadioGroup>
            </FormControl>
          </Stack>
          <h3>
            Toast Wrapper
            <IconButton
              onClick={() => {
                expandProperties("toast-wrapper-properties", toastWrapperIcon);
              }}
            >
              {toastWrapperIcon ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowUpIcon />
              )}
            </IconButton>
          </h3>
          <Stack
            id="toast-wrapper-properties"
            className="properties-type"
            spacing={2}
          >
            <FormControl
              component="fieldset"
              className="search-item"
              aria-label="placement top left center top right center bottom left bottom right bottom center top center"
            >
              <FormLabel component="legend">
                Placement&nbsp;&nbsp;
                <Tooltip title="Set the position of the toasts wrapper" arrow>
                  <i className="bi bi-info-circle-fill"></i>
                </Tooltip>
              </FormLabel>
              <RadioGroup
                aria-label="theme"
                name="placement-radio-buttons-group"
              >
                <FormControlLabel
                  value="bottom-right"
                  control={
                    <Radio
                      checked={placement === "bottom-right" ? true : false}
                      onChange={placementChanged}
                    />
                  }
                  label="Bottom Right"
                />
                <FormControlLabel
                  value="bottom-center"
                  control={<Radio onChange={placementChanged} />}
                  label="Bottom Center"
                />
                <FormControlLabel
                  value="bottom-left"
                  control={<Radio onChange={placementChanged} />}
                  label="Bottom Left"
                />
                <FormControlLabel
                  value="top-right"
                  control={<Radio onChange={placementChanged} />}
                  label="Top Right"
                />
                <FormControlLabel
                  value="top-center"
                  control={<Radio onChange={placementChanged} />}
                  label="Top Center"
                />
                <FormControlLabel
                  value="top-left"
                  control={<Radio onChange={placementChanged} />}
                  label="Top Left"
                />
                <FormControlLabel
                  value="right-center"
                  control={<Radio onChange={placementChanged} />}
                  label="Right Center"
                />
                <FormControlLabel
                  value="left-center"
                  control={<Radio onChange={placementChanged} />}
                  label="Left Center"
                />
                <FormControlLabel
                  value="center"
                  control={<Radio onChange={placementChanged} />}
                  label="Center"
                />
              </RadioGroup>
            </FormControl>
            <div className="search-item" aria-label="can user remove all text">
              <Tooltip title="This option add a button can remove all toasts when the option set to true">
                <FormControlLabel
                  checked={userCanRemoveAll}
                  control={<Checkbox onChange={canUserRemoveAllChanged} />}
                  label="Can User Remove All"
                />
              </Tooltip>
              <div id="can-user-remove-all">
                <TextField
                  label="Remove All Text"
                  size="small"
                  variant="outlined"
                  onChange={removeAllTextChanged}
                />
              </div>
            </div>
            <Tooltip title="This option restricts the number of toasts that will displayed at one time. The overflowed toasts are added to a queue then will displayed later when there is an empty place.">
              <TextField
                className="search-item"
                aria-label="limit"
                label="Limit"
                size="small"
                variant="outlined"
                onChange={limitChanged}
                type="number"
              />
            </Tooltip>
            <TextField
              className="search-item"
              aria-label="spacing"
              label="Spacing"
              size="small"
              variant="outlined"
              onChange={spacingChanged}
              type="number"
            />
          </Stack>
        </div>
      </div>
      <main>
        <ToastWrapper
          ref={wrapper}
          placement={placement}
          limit={limit}
          userCanRemoveAll={userCanRemoveAll}
          removeAllText={removeAllText}
          spacing={parseInt(spacing)}
        />
        <div id="controls">
          <Button variant="contained" onClick={addToast}>
            Add Toast
          </Button>
          <Button
            variant="contained"
            onClick={addRandomToastClicked}
            color="success"
          >
            Add Random Toast
          </Button>
          <Stack direction="row" spacing="10" style={{ width: "100%" }}>
            <Button
              variant="contained"
              onClick={addToastsGroup}
              color="warning"
            >
              Add{" "}
              <div
                type="number"
                contentEditable
                id="add-toasts-group"
                tabIndex="0"
              >
                5
              </div>{" "}
              toasts at the same time
            </Button>
            <FormControlLabel
              checked={random}
              control={<Checkbox onChange={randomChanged} />}
              label="Random"
            />
          </Stack>
          <Button
            onClick={() => {
              alert(wrapper.current.getQueueToastsNumber());
            }}
          >
            Get Queue Length
          </Button>
          <Button
            onClick={() => {
              alert(wrapper.current.getToastsNumber());
            }}
          >
            Get Toasts Number
          </Button>
          <Button
            onClick={() => {
              wrapper.current.removeAll();
            }}
            variant="contained"
            color="error"
          >
            Remove All Toasts
          </Button>
          <Button
            onClick={() => {
              wrapper.current.clearQueue();
              alert("Queue Cleared!");
            }}
            variant="outlined"
            color="error"
          >
            Clear Queue
          </Button>
          <Button variant="contained" color="success" onClick={generateCode}>
            Generate & Copy Code
          </Button>
        </div>
        <SyntaxHighlighter
          language="javascript"
          id="highlighter"
          style={dracula}
          showLineNumbers
        >
          {generatedCode}
        </SyntaxHighlighter>
      </main>
    </div>
  );
}
